export default __webpack_public_path__ + "building-icon-voilet.svg";